module.exports = __webpack_public_path__ + "img/background.2f8c34a6.jpg";